export default {
  confirmDelete: {
    header: 'Confirm Reset',
    message:
    'Deleting this parameter will cause the parameter of the next higher-level asset to apply to {asset}.\nIf none of the parent assets define the parameter, the default value will be used instead.\n\nAre you sure you want to delete the parameter \'{parameter}\' for \'{asset}\'?',
  },
};
